module.exports = __webpack_public_path__ + "assets/75c5c08806eb78c1c317b52fcc371bf4.png";